import { formatNumberWithCommas } from "src/utils/utils";
import moment from 'moment';
import { InquiryModes } from "src/Library/Constants";
import AirModeIcon from "src/components/common/icons/AirModeIcon";
import DomesticTruckIcon from "src/components/common/icons/DomesticTruckIcon";
import React from "react";
import TrailerModeIconBlack from "src/components/common/icons/TrailerModeIconBlack";
import TransitShipIcon from "src/components/common/icons/TransitShipIcon";

const { FCL, LCL, AIRCARGO, DOMESTIC, TRAILER, RPTL } = InquiryModes;


// Format currency helper
const formatCurrency = (amount: number, currency: string) => {
    if (!amount) return '-';
    return `${currency} ${formatNumberWithCommas(amount.toFixed(2))}`;
};

const formatDate = (date: string) => {
    if (!date) return '-';
    return moment(date).format('DD MMM YYYY');
};

const getTransitIcon = (mode: InquiryModes) => {
    switch (mode) {
        case AIRCARGO:
            return <AirModeIcon />;
        case DOMESTIC: 
            return <DomesticTruckIcon strokeColor={'#000'} fill={'#000'} />
        case TRAILER: 
            return <TrailerModeIconBlack fill={'#666'}/>
        case RPTL:
            return <DomesticTruckIcon strokeColor={'#000'} fill={'#000'} />
        default:
            return <TransitShipIcon />;
    }
}

export { formatCurrency, formatDate, getTransitIcon };
